import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { IPromoModalProps } from '@cian/frontend-newbuilding-promo-modal-widget';
import { useNewbuildingLinks } from './useNewbuildingLinks';
import { selectPromoDetails } from '../../../selectors/promoDetails';

export const usePreparedPromo = (): IPromoModalProps['promo'] | null => {
  const promo = useSelector(selectPromoDetails);
  const availableJks = useNewbuildingLinks(promo);

  return useMemo(() => {
    if (!promo) {
      return null;
    }

    return {
      authorName: `Застройщик ${promo.formattedBuilderName || promo.providerName}`,
      name: promo.promoName,
      type: promo.promoType,
      features: promo.promoProps.map(prop => ({
        name: prop.title,
        value: prop.value,
        valueChange: prop.valueChange,
      })),
      banks: promo.banks.map((bank, i) => ({
        id: i,
        name: bank.name,
        logoUrl: bank.logo,
      })),
      description: promo.promoDescription,
      availableJks,
      labels: promo.labels,
      fullCreditPriceTitle: promo.fullCreditPriceTitle,
      availablePurchaseTerms: promo.availablePurchaseTerms,
      mortgageLegalInfo: promo.promoLegalTerms,
    } as IPromoModalProps['promo'];
  }, [promo, availableJks]);
};
